// extracted by mini-css-extract-plugin
export default {"srOnly":"Loader_srOnly__Y4RXk","srOnlyFocusable":"Loader_srOnlyFocusable__Xdjuc","loader":"Loader_loader__iHwVs","spinny-spin":"Loader_spinny-spin__bE4m7"};